import { z } from 'zod';
import { ObjectIdSchema } from '../../shared/object-id.schema';
/** DELETE /api/v2/step-template/:id — soft delete */ export const DeleteStepTemplateResponseSchema = z.object({
    deletedTemplateId: ObjectIdSchema
});

//# sourceMappingURL=delete-step-template.schema.js.map